<template>
  <div class="record-list">
  <div class="content">
    <div v-if="items && items.length">
      <div v-for="(item, index) in items" :key="item.id">
        <div v-if="item.type === 'message'" class="mb-6">
          <div v-if="item.id === editId" class="border border-full-blue rounded">
            <edit-record-form :isPublic="item.isPublic" :date="item.date" :text="item.raw" :id="item.id" @cancel="cancelEdit" />
          </div>
          <div
            class="border border-white rounded"
            v-else>
            <record-item
              @edit="editItem(item)"
              :relativePath="path"
              :item="item"
              :tabIndex="index + 2"
              :showUrls="showUrls" />
          </div>
        </div>
        <div
          v-else-if="item.type === 'date'"
          class="pt-2 text-xs font-normal py-2 relative  rounded-t mb-2"
        >
          {{item.text}}
        </div>
      </div>
    </div>
    <div v-else class="mt-6 py-6 text-center text-lg border-t-4 text-gray border-b-4 border-gray-light">No notes here.</div>
  </div>
  </div>
</template>

<script>
 import {mapState} from 'vuex';

 import RecordItem from '@/components/RecordItem';
 import EditRecordForm from '@/components/EditRecordForm';

 const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

 export default {
   name: 'record-list',

   props: {
     path: {
       type: String,
       default: '/'
     },
     records: {
       type: Array,
       default: () => []
     },
     showUrls: {
       type: Boolean,
       default: true
     }
   },

   data () {
     return {
       editId: ''
     }
   },
   components: {RecordItem, EditRecordForm},

   computed: Object.assign(
     {},
     {
       items () {
         let curDate = ''

         const renderItems = []

         this.records.forEach(r => {
           const d = new Date(r.date)
           const dateStr = `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`
           if (curDate !== dateStr) {
             renderItems.push({type: 'date', text: dateStr})
             curDate = dateStr
           }

           renderItems.push({
             type: 'message',
             text: r.body,
             id: r.id,
             path: r.path,
             date: r.date,
             urls: r.urls,
             txs: r.txs,
             bangs: r.bangs,
             todo: r.todo === 'TODO' ? true : r.todo === 'DONE' ? false : undefined,
             tags: r.tags,
             formulas: r.formulas,
             parsed: r.parsed_result,
             raw: r.raw,
             isPublic: r.is_public,
           })
         })

         return renderItems;
       },
   }),
   methods: {
     editItem (item) {
       this.editId = item.id
     },
     cancelEdit () {
       this.editId = ''
     }
   }
 }
</script>

<style scoped>
 .record {
   word-break: break-all;
   word-break: break-word;
   overflow-wrap: anywhere;
 }
</style>
